module.exports = __webpack_public_path__ + "assets/img/advancedSearch.d44dd16d.png";